module.exports = __webpack_public_path__ + "img/priorityTypes.878e19f7.svg";